import { Component, OnInit, Input } from '@angular/core';
import { GridColumn, DateFormat, NumberFormat, CrawfordSnackbarService, CrawfordSpinnerService, ITabComponent } from 'crawford-shell';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/zip';

import { global } from '../../app.settings';

import { ClaimReservesPaymentsSummary } from '../model/claim-reserves-payments-summary.model';
import { ClaimReserve } from '../model/claim-reserve.model';
import { ClaimPayment } from '../model/claim-payment.model';
import { ClaimService } from '../claim.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-claim-reserves-payments',
  templateUrl: './claim-reserves-payments.component.html',
  styleUrls: ['./claim-reserves-payments.component.scss']
})
export class ClaimReservesPaymentsComponent implements OnInit, ITabComponent {

  @Input() public crawfordRef: string;
  @Input() public claimOpen: boolean;
  @Input() public source: string;

  private dataLoaded = false;
  public reservesPaymentsSummaryForm: FormGroup;
  public paymentsReservesSummary: ClaimReservesPaymentsSummary;
  public reservesData: ClaimReserve[];
  public paymentsData: ClaimPayment[];

  public df: DateFormat = {
    type: 'date',
    format: 'dd/MM/yyyy'
  };

  public cf: NumberFormat = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: 'gbp',
    format: '£#,#.##'
  };

  public displayColumns: GridColumn[] = [
    new GridColumn('type', 'Type'),
    new GridColumn('value', 'Value', { type: 'number', format: this.cf }),
    new GridColumn('date', 'Date', { type: 'date', format: this.df })
  ];

  constructor(private formBuilder: FormBuilder,
    private claimService: ClaimService,
    private snackbarService: CrawfordSnackbarService,
    private spinnerService: CrawfordSpinnerService,
  private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.createReservesPaymentsForm();
   }

  private createReservesPaymentsForm() {
    this.reservesPaymentsSummaryForm = this.formBuilder.group({
      totalClaim: new FormControl(),
      adjusterDeductions: new FormControl(),
      currentReserve: new FormControl(),
      currentReservePlusPaid: new FormControl(),
      notCovered: new FormControl(),
      firstReserve: new FormControl(),
      excessAverageLimits: new FormControl(),
      totalInterimPayments: new FormControl(),
      totalAdjustments: new FormControl()
    });
  }

  private setFormValues() {
    const currencyFormat = new Intl.NumberFormat('en-gb', { style: 'currency', currency: 'GBP'});
    this.reservesPaymentsSummaryForm.reset({
      totalClaim: currencyFormat.format(this.paymentsReservesSummary.totalClaim),
      adjusterDeductions: currencyFormat.format(this.paymentsReservesSummary.adjusterDeductions),
      currentReserve: currencyFormat.format(this.paymentsReservesSummary.currentReserve),
      currentReservePlusPaid: currencyFormat.format(this.paymentsReservesSummary.currentReservePlusPaid),
      notCovered: currencyFormat.format(this.paymentsReservesSummary.notCovered),
      firstReserve: currencyFormat.format(this.paymentsReservesSummary.firstReserve),
      excessAverageLimits: currencyFormat.format(this.paymentsReservesSummary.excessAverageLimits),
      totalInterimPayments: currencyFormat.format(this.paymentsReservesSummary.totalInterimPayments),
      totalAdjustments: currencyFormat.format(this.paymentsReservesSummary.totalAdjustments)
    });
  }

  loadData(): void {
    if (!this.dataLoaded) {
      this.spinnerService.show('claimReservesPaymentsSpinner');
      if (this.crawfordRef) {
        Observable.zip(
          this.claimService.getClaimReservesPaymentsSummary(this.crawfordRef, this.source),
          this.claimService.getClaimReserves(this.crawfordRef, this.source),
          this.claimService.getClaimPayments(this.crawfordRef, this.source)
        ).subscribe(
          (reservesPaymentsData) => {
            this.loadReservesPaymentsSummary(reservesPaymentsData[0]);
            this.loadReserves(reservesPaymentsData[1]);
            this.loadPayments(reservesPaymentsData[2]);
            this.dataLoaded = true;
            this.spinnerService.hide('claimReservesPaymentsSpinner');
          },
          error => {
            this.spinnerService.hide('claimReservesPaymentsSpinner');
          }
        );
      } else {
        this.spinnerService.hide('claimReservesPaymentsSpinner');
        this.snackbarService.displayErrorMessage('No Crawford Reference provided to obtain Reserves and Payments');
      }
    }
  }

  private loadReservesPaymentsSummary(summary): void {
    if (summary) {
      this.paymentsReservesSummary = summary;
      this.setFormValues();
      this.reservesPaymentsSummaryForm.disable();
    } else {
      this.snackbarService.displayErrorMessage('No Reserves and Payments Summary was found for Claim: ' + this.crawfordRef);
    }
  }

  private loadReserves(reserves): void {
    if (reserves) {
      this.reservesData = reserves;
    } else {
      this.reservesData = [];
    }
  }

  private loadPayments(payments): void {
    if (payments) {
      this.paymentsData = payments;
    } else {
      this.paymentsData = [];
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-reserves-payments/claim-reserves-payments.component.ts